import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewEncapsulation,
  input,
  viewChild,
} from '@angular/core';

import { BadgeColor } from '@coworkrz/core/types';
const BADGE_HOST_ATTRIBUTES: string[] = ['ui-badge'];

const BADGE_STYLE_CLASSES: { [name: string]: { [name: string]: string } } = {
  'ui-badge': {
    default: '',
    'red-light': 'bg-red-50 w-[20px] h-[20px] text-white !p-0 text-[9px]',
    purple: 'bg-purple-95 border-purple-80 text-primary',
    green: 'bg-green-95 border-green-90 text-green-40',
    red: 'bg-red-90 border-red-80 text-red-50',
    gray: 'bg-neutral-95 border-neutral-90 text-neutal-10',
    orange: 'bg-orange-50 border-0 text-white font-light',
  },
};

@Component({
  selector: 'ui-badge',
  imports: [],
  exportAs: 'uiBadge',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './badge.component.html',
})
export class BadgeComponent implements AfterViewInit {
  readonly color = input<BadgeColor>('default');
  readonly badgeText = input.required<string>();
  readonly badgeElement = viewChild.required<ElementRef>('badgeRef');
  ngAfterViewInit(): void {
    // For each of the attributes, add text and background classes corresponding
    // to each variant

    for (const variant of BADGE_HOST_ATTRIBUTES) {
      const color = this.color();
      if (BADGE_STYLE_CLASSES[variant]?.[color]) {
        this.addToClassList(BADGE_STYLE_CLASSES[variant][color]);
      }
    }
  }
  private addToClassList(className: string) {
    const classes = className.split(' ');
    this.badgeElement().nativeElement.classList.add(...classes);
  }
  private hasHostAttributes(...attributes: string[]) {
    return attributes.some((attribute) =>
      this.badgeElement().nativeElement.hasAttribute(attribute)
    );
  }
}
